import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { useNavigate } from 'react-router'
import { COMPONENTS } from '../../../../../routers/constants'

export const GotoDownloadedFiles = () => {
  const navigate = useNavigate()

  const onClick = () => {
    navigate(COMPONENTS.library.components.downloadFiles.route)
  }

  return (
    <Element
      elementName="span"
      style={{ color: '#2C73E8' }}
      className="fw600 cursorPointer"
      onClick={onClick}
    >
      <Translate value="userManagement.orderManagement.orderDetail.GO_TO_DOWNLOADED_FILES" />
    </Element>
  )
}
